/* eslint-disable react/prop-types */
import { useCallback, useState } from "react";
import "./index.scss";

export const BrandDescription = ({
  brandName,
  description,
  defaultMaximumLines,
  isApple
}) => {
  const [maximumLines, setMaximumLines] = useState(defaultMaximumLines);
  const isExpanded = maximumLines === null;
  const toggleShowMore = useCallback(() => {
    isExpanded ? setMaximumLines(defaultMaximumLines) : setMaximumLines(null);
  }, [isExpanded, defaultMaximumLines]);
  const toggleMessage = `see ${isExpanded ? "less" : "more"}`;
  const title = isApple
    ? `Buy ${brandName} & Top Deals`
    : `Buy ${brandName} Gift Cards & Top Deals`;

  return (
    <div className="brand-description" data-testid="brand-description">
      <h1 className="brand-title">{title}</h1>
      <p
        className="description-sidebar"
        style={{
          WebkitLineClamp: maximumLines
        }}
      >
        {description}
      </p>
      <span className="show-more" onClick={toggleShowMore}>
        {toggleMessage}
      </span>
    </div>
  );
};
